import Service from '@ember/service';
import { TrackedObject } from 'tracked-built-ins';

export default class LocalStorageService extends Service {
  _localStorageCache = new TrackedObject();

  getItem(key: string): string | null {
    // read _localStorageCache to trigger autotracking behavior, but don't do anything with its value
    void this._localStorageCache[key];
    return window.localStorage.getItem(key);
  }

  setItem(key: string, value: unknown): void {
    if (value == null) {
      this.removeItem(key);
    } else {
      this._localStorageCache[key] = value;
      // @ts-ignore-error - TS seems to have the wrong signature for window.localStorage.setItem
      window.localStorage.setItem(key, value);
    }
  }

  removeItem(key: string): void {
    delete this._localStorageCache[key];
    window.localStorage.removeItem(key);
  }
}
